import { useState } from 'react';

/**
 * Custom hook to manage install help modal state
 * Provides modal open/close/toggle functionality for installation guidance
 *
 * @returns Object with modal state and control functions
 */
export const useInstallHelpModal = () => {
  const [opened, setOpened] = useState(false);

  const open = () => {
    setOpened(true);
  };

  const close = () => {
    setOpened(false);
  };

  const toggle = () => {
    setOpened((prev) => !prev);
  };

  return {
    opened,
    open,
    close,
    toggle,
  };
};
